import { Component, Input, Output, EventEmitter } from '@angular/core';


export interface UiTab {
  id: string;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'ui-tabs',
  standalone: true,
  imports: [],
  templateUrl: './ui-tabs.component.html',
  styleUrl: './ui-tabs.component.scss'
})
export class UiTabsComponent {
  @Input() tabs: UiTab[] = [];
  @Input() activeTabId: string = '';
  @Input() boxed = false;
  @Input() lifted = false;
  @Output() tabChange = new EventEmitter<string>();

  onTabClick(tabId: string): void {
    if (this.activeTabId !== tabId) {
      this.tabChange.emit(tabId);
    }
  }

  isActive(tabId: string): boolean {
    return this.activeTabId === tabId;
  }

  get tabsClasses(): string {
    const classes = ['tabs', 'tabs-bordered'];

    if (this.boxed) {
      classes.push('tabs-boxed');
    }

    if (this.lifted) {
      classes.push('tabs-lifted');
    }

    return classes.join(' ');
  }
}

